import React from 'react'

const Navbar = () => {
  return (
    <nav className="blue">
      <div className="nav-wrapper">
        <a href="#!" className="brand-logo center">
          Todos
        </a>
      </div>
    </nav>
  )
}

export default Navbar
